import { createTheme } from "@mui/material/styles";
import { faIR } from "@mui/material/locale";

const commonComponents = {
  // ❌ IMPORTANT:
  // Do NOT set body.direction in CssBaseline.
  // Direction must come from html/body dir attribute (set by I18nProvider),
  // otherwise stylis-plugin-rtl + CSS direction can conflict.

  MuiSelect: {
    styleOverrides: {
      select: ({ theme }) => ({
        fontFamily: '"Vazir", "Roboto", sans-serif',
        fontWeight: 700,

        textAlign: theme.direction === "rtl" ? "right" : "left",
        display: "flex",
        alignItems: "center",
        justifyContent: theme.direction === "rtl" ? "flex-end" : "flex-start",

        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",

        paddingInlineStart: 10,
        paddingInlineEnd: 34,
      }),

      icon: () => ({
        insetInlineEnd: 8,
        color: "rgba(15, 23, 42, 0.45)",
      }),
    },
  },

  MuiInputBase: {
    styleOverrides: {
      root: () => ({
        fontFamily: '"Vazir", "Roboto", sans-serif',
      }),
      input: ({ theme }) => ({
        fontFamily: '"Vazir", "Roboto", sans-serif',
        fontWeight: 700,
        textAlign: theme.direction === "rtl" ? "right" : "left",
      }),
    },
  },

  MuiOutlinedInput: {
    styleOverrides: {
      root: () => ({
        fontFamily: '"Vazir", "Roboto", sans-serif',
      }),
      input: ({ theme }) => ({
        fontFamily: '"Vazir", "Roboto", sans-serif',
        fontWeight: 700,
        textAlign: theme.direction === "rtl" ? "right" : "left",
      }),
    },
  },

  MuiMenu: {
    styleOverrides: {
      paper: () => ({
        borderRadius: 14,
        border: "1px solid rgba(15, 23, 42, 0.08)",
        boxShadow: "0 14px 40px rgba(0, 0, 0, 0.12)",
        padding: 6,
      }),
      list: () => ({
        fontFamily: '"Vazir", "Roboto", sans-serif',
        fontWeight: 600,
      }),
    },
  },

  MuiMenuItem: {
    styleOverrides: {
      root: () => ({
        fontFamily: '"Vazir", "Roboto", sans-serif',
        fontWeight: 700,
        whiteSpace: "nowrap",
      }),
    },
  },

  MuiFormLabel: {
    styleOverrides: {
      root: ({ theme }) => ({
        fontFamily: '"Vazir", "Roboto", sans-serif',
        textAlign: theme.direction === "rtl" ? "right" : "left",
      }),
    },
  },

  MuiInputLabel: {
    styleOverrides: {
      root: ({ theme }) => ({
        fontFamily: '"Vazir", "Roboto", sans-serif',
        textAlign: theme.direction === "rtl" ? "right" : "left",
      }),
    },
  },
};

const rtlTheme = createTheme(
  {
    direction: "rtl",
    typography: {
      fontFamily: '"Vazir", "Roboto", sans-serif',
    },
    components: {
      ...commonComponents,
    },
  },
  faIR
);

export default rtlTheme;
